var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
$(document).on('input','.range_slider input[type="range"]',function(){
  var val = $(this).val();
  if(val == 101){$(this).siblings('.range_count_btn').find('.range_count').html('100+');}
  else{$(this).siblings('.range_count_btn').find('.range_count').html(val);}
});
$(document).on('keyup','#company_name_input ,#company_name_input_1',function(){
  var val = $(this).val();
  $('.q_company_name').html(val);
});
$(document).on('change','.toggle_box input[type=checkbox]',function(){
  // if($(this).is(':checked')){$(this).parent('.toggle_box').siblings('.toggle_box_content').slideDown();}
  // else{$(this).parent('.toggle_box').siblings('.toggle_box_content').slideUp();}
});
$(document).on('change','.box_grid input[type=radio]',function(){
  $(this).closest('.box_grid').find('.grid_block').removeClass('active');
  if($(this).is(':checked')){$(this).parent('.grid_block').addClass('active');}
});
$(document).on('click','.toggle_nav .toggle_action',function(){
  $(this).toggleClass('active');
  $(this).parent().siblings('.toggle_nav_content').slideToggle();
});
$(document).on('click','.Addons_action .Polygon_Icon',function(){
  $(this).toggleClass('active');
  $(this).closest('.package_box').siblings('.toggle_nav_content').slideToggle();
});
$(document).on('change','.serving_coffee_place input[type=radio]',function(){
  if($(this).is(':checked')){$('#quiz_step_1 .quiz_next_btn').removeAttr('disabled');}
});
$(document).on('change','.label_box select',function(){
  var vprice = $('option:selected', this).attr('data-price'),
      vserves = $('option:selected', this).attr('data-serves'),
      vweight = $('option:selected', this).attr('data-weight'),
      vweightunit = $('option:selected', this).attr('data-weightunit');
  $(this).siblings('.hidden_content').find('.product_price span').html(Shopify.formatMoney(vprice, window.theme.moneyFormat));
  $(this).siblings('.Price').val(vprice);
  if(vserves != '' || vserves != undefined){$(this).closest('.grid_block').find('input[name="select-coffee-product"]').attr('data-serves',vserves);}
  if(vweight != '' || vweight != undefined){$(this).closest('.grid_block').find('input[name="select-coffee-product"]').attr('data-weight',vweight);}
  if(vweightunit != '' || vweightunit != undefined){$(this).closest('.grid_block').find('input[name="select-coffee-product"]').attr('data-weightunit',vweightunit);}
});
$(document).on('click', '.quantity_icons .qty-icons', function() {
  var $this = $(this),
      $input = $(this).siblings('input'),
      val = parseInt($input.val()),
      valMax = 100000000000000000000000000000,
      valMin = $input.attr('min') || 1;
  if ($input.attr('max') != null){
    valMax = $input.attr('max');
  }
  if(isNaN(val) || val < valMin) {
    $input.val(valMin);
    return false;
  } else if (val > valMax) {
    $input.val(valMax);
    return false;
  }
  if($this.data('action') == 'increase-picker-quantity') {
    if(val < valMax) $input.val(val + 1);
  } else {if(val > valMin) $input.val(val - 1);}
  $input.trigger('change');
});
$(document).on('click','.quiz_next_btn',function(){
  QuizSteps($(this));
});
$(document).on('click','.quiz_previous_btn',function(){
  var prev = $(this).data('prev-step');
  var next = $(this).data('next-step');
  $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
  $('#'+prev+'').fadeOut();
  $('#'+next+'').fadeIn();$('#'+next+'').css('animation-name','fadeInUp');$('#'+next+'').css('animation-duration','1.7s');
  let dataval = $('.serving_coffee_place input[type=radio]:checked').data('value');
  if(next == 'quiz_step_3'){
    $('.coffee_Traditional_barista_machine .toggle_box input[type="checkbox"]').prop("checked", false);
    $('.machine_box_grid .toggle_box_content').fadeOut();
    $('.Product_Box_Grid .grid_block input').prop("checked", false);
  }else if(next == 'quiz_step_5'){
    $('.coffee_Quantity_packages_info .Box_Quantity_Inner').html('');
    $('.coffee_products_data').html('');
  }
});
function QuizSteps(_this){
  var prev = _this.data('prev-step');
  var next = _this.data('next-step');
  if(next == 'quiz_step_2'){
    $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
    $('#'+prev+'').fadeOut();
    $('#'+next+'').fadeIn();
    let dataval = $('.serving_coffee_place input[type=radio]:checked').data('value');
    console.log(dataval)
    if(dataval == 'franchise-quiz'){
      location.href = '/pages/contact-us'
    }else{
      $('#quiz_step_2 .quiz_boxes').fadeOut();
      $('#quiz_step_2 [data-value="'+dataval+'"]').fadeIn();
      $('#quiz_step_2 [data-value="'+dataval+'"]').css('animation-name','fadeInUp');
      $('#quiz_step_2 [data-value="'+dataval+'"]').css('animation-duration','1.7s');
    }
  }else if(next == 'quiz_step_3'){
    let servingval = $('.serving_coffee_place input[type="radio"]:checked').data('value');
    var emailReg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if(servingval == 'office-quiz'){
      let company_name = $('#company_name_input').val();
      let company_email = $('#company_email_input').val();
      let company_employees = $('#company_employees_input').val();
      if(company_name != '' && company_name != undefined && company_email != '' && company_email != undefined && company_employees != '' && company_employees != undefined){
        if(!emailReg.test(company_email)){
          $('html, body').animate({scrollTop: $("#company_email_input").offset().top - 200}, 1000);
          $("#company_email_input").after('<span class="error">Enter a valid email address.</span>');
          setTimeout(function(){$('span.error').fadeOut();},5000);
        }else{
          $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
          $('#'+prev+'').fadeOut();
          $('#'+next+'').fadeIn();
          $('#quiz_step_3 .quiz_boxes').fadeOut();
          $('#quiz_step_3 [data-value="'+servingval+'"]').fadeIn();
          $('#quiz_step_3 [data-value="'+servingval+'"]').css('animation-name','fadeInUp');
          $('#quiz_step_3 [data-value="'+servingval+'"]').css('animation-duration','1.7s');
        }
      }else{
        $('html, body').animate({scrollTop: $("#quiz_step_2").offset().top - 100}, 1000);
        if(company_name == '' || company_name == undefined){$('#company_name_input').css('border-color','red');}
        if(company_email == '' || company_email == undefined){$('#company_email_input').css('border-color','red');}
      }
    }else if(servingval == 'hospitality-quiz'){
      let company_name = $('#company_name_input_1').val();
      let company_email = $('#company_email_input_1').val();
      let company_type = $('.about_your_business .radio_block input[type="radio"]:checked').val();
      let company_Cups_input = $('#company_Cups_input').val();
      if(company_name != '' && company_name != undefined && company_email != '' && company_email != undefined && company_type != '' && company_type != undefined && company_Cups_input != '' && company_Cups_input != undefined){
        if(!emailReg.test(company_email)){
          $('html, body').animate({scrollTop: $("#company_email_input_1").offset().top - 200}, 1000);
          $("#company_email_input_1").after('<span class="error">Enter a valid email address.</span>');
          setTimeout(function(){$('span.error').fadeOut();},5000);
        }else{
          $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
          $('#'+prev+'').fadeOut();
          $('#'+next+'').fadeIn();
          $('#quiz_step_3 .quiz_boxes').fadeOut();
          $('#quiz_step_3 [data-value="'+servingval+'"]').fadeIn();
          $('#quiz_step_3 [data-value="'+servingval+'"]').css('animation-name','fadeInUp');
          $('#quiz_step_3 [data-value="'+servingval+'"]').css('animation-duration','1.7s');
        }
      }else{
        $('html, body').animate({scrollTop: $("#quiz_step_2").offset().top - 100}, 1000);
        if(company_name == '' || company_name != undefined){$('#company_name_input_1').css('border-color','red');}
        if(company_email == '' || company_email != undefined){$('#company_email_input_1').css('border-color','red');}
        if(company_type == '' || company_type == null || company_type == undefined){$('.about_your_business .radio_label').css('border-color','red');}
      }
    }
  }else if(next == 'quiz_step_4'){
    let brewval =  $('.brew_your_coffee_block input[type="radio"]:checked').data('value');
    if(brewval != '' && brewval != undefined){
      $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
      $('.step_four_quiz_box .machine_box_grid').fadeOut();
      $('.step_four_quiz_box .coffee_product_box').fadeOut();
      $('.step_four_quiz_box [data-value="'+brewval+'"]').fadeIn();
      $('#'+prev+'').fadeOut();
      $('#'+next+'').fadeIn();$('#'+next+'').css('animation-name','fadeInUp');$('#'+next+'').css('animation-duration','1.7s');
    }else{
      $('html, body').animate({scrollTop: $("#quiz_step_3").offset().top - 100}, 1000);
    }
    if(brewval == 'coffee_Brew_bags'){$('.quiz_title.coffee_product_quiz_title').hide();}else{$('.quiz_title.coffee_product_quiz_title').show();};
  }else if(next == 'quiz_step_5'){
    let brewval =  $('.brew_your_coffee_block input[type="radio"]:checked').data('value');
    if(brewval != 'coffee_Brew_bags'){
      let coffee_machine = $('.coffee_Traditional_barista_machine .toggle_box input[type="checkbox"]:checked').val();
      if(coffee_machine == 'Yes'){
        var coffee_machine_val = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').val();
        var coffee_product_val = $('.coffee_product_box input:checked').val();
        if(coffee_machine_val != '' && coffee_product_val != '' && coffee_machine_val != undefined && coffee_machine_val != null && coffee_product_val != undefined && coffee_product_val != null){
          $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
          $('#'+prev+'').fadeOut();
          $('#'+next+'').fadeIn();$('#'+next+'').css('animation-name','fadeInUp');$('#'+next+'').css('animation-duration','1.7s');
        }else{
          if(coffee_machine_val == '' || coffee_machine_val == undefined || coffee_machine_val == null){$('.coffee_Traditional_barista_machine').css('border-color','red');}
          if(coffee_product_val == '' || coffee_product_val == undefined || coffee_product_val == null){$('.coffee_product_box .label_box').css('border-color','red');}
          $('html, body').animate({scrollTop: $("#quiz_step_4").offset().top - 100}, 1000);
          return;
        }
      }else{
        var coffee_product_val = $('.coffee_product_box input:checked').val();
        if(coffee_product_val != '' && coffee_product_val != undefined && coffee_product_val != null){
          $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
          $('#'+prev+'').fadeOut();
          $('#'+next+'').fadeIn();$('#'+next+'').css('animation-name','fadeInUp');$('#'+next+'').css('animation-duration','1.7s');
        }else{
          $('.coffee_product_box .label_box').css('border-color','red');
          $('html, body').animate({scrollTop: $("#quiz_step_4").offset().top - 100}, 1000);
          return;
        }
      }
    }else{
      let coffee_bags_val = $('.coffee_Brew_bags_option input[type="checkbox"]:checked').val();
      if(coffee_bags_val != '' && coffee_bags_val != undefined && coffee_bags_val != null){
        $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
        $('#'+prev+'').fadeOut();
        $('#'+next+'').fadeIn();$('#'+next+'').css('animation-name','fadeInUp');$('#'+next+'').css('animation-duration','1.7s');
      }else{
        $('.coffee_Brew_bags_option .label_box').css('border-color','red');
        $('html, body').animate({scrollTop: $("#quiz_step_4").offset().top - 100}, 1000);
        return;
      }
    }
  }else if(next == 'quiz_step_6'){
    $('html, body').animate({scrollTop: $("body").offset().top}, 1000);
    $('#'+prev+'').fadeOut();
    $('#'+next+'').fadeIn();$('#'+next+'').css('animation-name','fadeInUp');$('#'+next+'').css('animation-duration','1.7s');
    let brewval =  $('.brew_your_coffee_block input[type="radio"]:checked').data('value');
    //     Add data To Last Step
    var coffee_machine = $('.coffee_Traditional_barista_machine .toggle_box input[type="checkbox"]:checked').val();
    if(coffee_machine == 'Yes'){
      var coffee_machine_title = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').siblings('label').find('.title').html(),
          coffee_machine_price = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').siblings('label').find('.Price').val(),
          coffee_machine_discription = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').siblings('label').find('.product_discription').html(),
          coffee_machine_img = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').siblings('label').find('.image_block').html(),
          Coffee_Machine_Product = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').val();
      $('.machine_info').find('.machine_name').html(coffee_machine_title);
      $('.machine_product_data').find('.product_title').html(coffee_machine_title);
      $('.machine_product_data').find('.product__description').html(coffee_machine_discription);
      $('.machine_product_data').find('.image_block').html(coffee_machine_img);
      $('#Coffee_Machine_Product').val(Coffee_Machine_Product);
      $('.atc_machine_price').html(Shopify.formatMoney(coffee_machine_price, window.theme.moneyFormat));
      $('.atc_machine_price').attr('data-price',coffee_machine_price);
    }else{
      $('.coffee_Machine_packages_info').hide();
      $('.atc_machine').hide();
    }
    var coffeeNameArry = [],
        coffeehandleArry = [],
        coffeePrice = 0,
        mval = $('.brew_your_coffee_block input[type="radio"]:checked').data('value');
    if(mval == 'coffee_Traditional_barista_machine' || mval == 'coffee_Brew_bags'){
      $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]').each(function(){
        var self = $(this);
        if($(this).is(':checked')){
          console.log('iff');
          let getId = self.val(),
              getserves = self.attr('data-serves'),
              getweight = self.attr('data-weight'),
              getweightunit = self.attr('data-weightunit'),
              getHandle = self.attr('data-product-handle'),
              getPrice = self.siblings('label').find('.Price').val(),
              getTitle = self.siblings('label').find('.title').html(),
              getDiscription = self.siblings('label').find('.product_discription').html(),
              getImage = self.siblings('label').find('.image_block').html();
          let makeHTML = '<div class="toggle_nav_box quiz_product_box"><div class="product_images_title"><h2 class="quiz_title product_title">'+getTitle+'</h2><span class="image_block">'+getImage+'</span></div> <div class="product__description">'+getDiscription+'</div> <div class="product_etc_info"></div></div>';
          let makeHTML2 = '<div class="box_quantity_info" data-price="'+getPrice+'"><div class="quiz_box_coffee_name">'+getTitle+'</div><div class="quiz_box_info box_quantity"><img srcset="https://cdn.shopify.com/s/files/1/0568/6234/3333/files/cup-fill_44x.png?v=1651654817 44w" src="https://cdn.shopify.com/s/files/1/0568/6234/3333/files/cup-fill_1x.png?v=1651654817" sizes="44px" alt="Cafe" loading="lazy"><span class="quantity_name"><span class="serves">'+getserves+'</span>x<span class="weight" data-value="'+getweight+'">'+getweight+'</span>'+getweightunit+'</span> </div><span class="quantity_icons"><span class="qty-icons qty-minus" data-action="decrease-picker-quantity"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="45" viewBox="0 0 16 45"><text id="_-" data-name="-" transform="translate(8 35)" font-size="45" font-family="Helvetica-Bold, Helvetica" font-weight="700"><tspan x="-7" y="0">-</tspan></text></svg></span><input name="quantity" aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" value="1" size="3" data-id="'+getHandle+'"><span class="qty-icons qty-plus" data-action="increase-picker-quantity"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33"><text id="_" data-name="+" transform="translate(10 25)" font-size="33" font-family="Helvetica-Bold, Helvetica" font-weight="700"><tspan x="-9" y="0">+</tspan></text></svg></span></span></div>';
          $('.coffee_products_data').append(makeHTML);
          $('.coffee_Quantity_packages_info .Box_Quantity_Inner').append(makeHTML2);
          coffeeNameArry.push(getTitle);
          coffeehandleArry.push(getHandle);
          coffeePrice = parseInt(coffeePrice) + parseInt(getPrice);
        }
      });
      $('.Coffee_info .Coffee_name').html(coffeeNameArry);
    }else{
      console.log('else');
      let getId = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').val(),
          getserves = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').attr('data-serves'),
          getweight = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').attr('data-weight'),
          getweightunit = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').attr('data-weightunit'),
          getHandle = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').attr('data-product-handle'),
          getPrice = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').siblings('label').find('.Price').val(),
          getTitle = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').siblings('label').find('.title').html(),
          getDiscription = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').siblings('label').find('.product_discription').html(),
          getImage = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').siblings('label').find('.image_block').html();
      console.log(getId,getserves,getweight,getweightunit,getHandle,getPrice,getTitle,getDiscription,getImage,'aaaaaaaaa')
      let makeHTML = '<div class="toggle_nav_box quiz_product_box"><div class="product_images_title"><h2 class="quiz_title product_title">'+getTitle+'</h2><span class="image_block">'+getImage+'</span></div> <div class="product__description">'+getDiscription+'</div> <div class="product_etc_info"></div></div>';
      let makeHTML2 = '<div class="box_quantity_info" data-price="'+getPrice+'"><div class="quiz_box_coffee_name">'+getTitle+'</div><div class="quiz_box_info box_quantity"><img srcset="https://cdn.shopify.com/s/files/1/0568/6234/3333/files/cup-fill_44x.png?v=1651654817 44w" src="https://cdn.shopify.com/s/files/1/0568/6234/3333/files/cup-fill_1x.png?v=1651654817" sizes="44px" alt="Cafe" loading="lazy"><span class="quantity_name"><span class="serves">'+getserves+'</span>x<span class="weight" data-value="'+getweight+'">'+getweight+'</span>'+getweightunit+'</span> </div><span class="quantity_icons"><span class="qty-icons qty-minus" data-action="decrease-picker-quantity"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="45" viewBox="0 0 16 45"><text id="_-" data-name="-" transform="translate(8 35)" font-size="45" font-family="Helvetica-Bold, Helvetica" font-weight="700"><tspan x="-7" y="0">-</tspan></text></svg></span><input name="quantity" aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" value="1" size="3" data-id="'+getHandle+'"><span class="qty-icons qty-plus" data-action="increase-picker-quantity"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33"><text id="_" data-name="+" transform="translate(10 25)" font-size="33" font-family="Helvetica-Bold, Helvetica" font-weight="700"><tspan x="-9" y="0">+</tspan></text></svg></span></span></div>';
      coffeehandleArry.push(getHandle);
      $('.coffee_products_data').append(makeHTML);
      $('.coffee_Quantity_packages_info .Box_Quantity_Inner').append(makeHTML2);
      $('.Coffee_info .Coffee_name').html(getTitle);
      $('.quiz_box_coffee_name').html(getTitle);
      coffeePrice = parseInt(coffeePrice) + parseInt(getPrice);
    }
    let Reoccurrence = $('.Reoccurrence_info input[type="radio"]:checked').val();
    $('.atc_coffee_price').html(Shopify.formatMoney(coffeePrice, window.theme.moneyFormat));
    $('.atc_coffee_price').attr('data-price',coffeePrice);
    $('.product_subsciption').html(Reoccurrence);

    let addonprice = $('.atc_addons_price').attr('data-price'),
        machineprice = $('.atc_machine_price').attr('data-price'),
        coffeeprice = $('.atc_coffee_price').attr('data-price'),
        totalval = parseInt(coffeeprice) + parseInt(addonprice),
        grandtotalval = parseInt(machineprice) + parseInt(coffeeprice) + parseInt(addonprice);
    $('.grand_total_price').html(Shopify.formatMoney(grandtotalval, window.theme.moneyFormat));
    $('.subsciption_total_price').html(Shopify.formatMoney(totalval, window.theme.moneyFormat));

    let customer_palce = $('.serving_coffee_place input[type="radio"]:checked').val(),
        servingval = $('.serving_coffee_place input[type="radio"]:checked').data('value');
    $('.cart_customer_palce').val(customer_palce);
    if(servingval == 'office-quiz'){
      let company_name = $('#company_name_input').val(),
          company_email = $('#company_email_input').val(),
          company_employees = $('#company_employees_input').val();
      if(company_employees == '101'){company_employees = '100+';}
      $('.cart_company_name').val(company_name);
      $('.cart_company_email').val(company_email);
      $('.cart_company_employees').val(company_employees);
    }else if(servingval == 'hospitality-quiz'){
      let company_name = $('#company_name_input_1').val(),
          company_email = $('#company_email_input_1').val(),
          company_type = $('.about_your_business .radio_block input[type="radio"]:checked').val(),
          company_cups_input = $('#company_Cups_input').val();
      if(company_cups_input == '101'){company_cups_input = '100+';}
      $('.cart_company_name').val(company_name);
      $('.cart_company_email').val(company_email);
      $('.cart_business_type').val(company_type);
      $('.cart_cups_per_day').val(company_cups_input);
    }
// questions
    let cart_power = $('.power_info input[type="radio"]:checked').val(),
        cart_Car = $('.Car_info input[type="radio"]:checked').val(),
        gym_subscription = $('.gym_info input[type="radio"]:checked').val();
    if($('#brew_coffee_in_front_of_customers[type="checkbox"]:checked').val() != undefined){var brew_coffee_front_of_customers = $('#brew_coffee_in_front_of_customers[type="checkbox"]:checked').val();}
    else{var brew_coffee_front_of_customers = 'No';}
    if($('#Do_you_enjoy_the_opera[type="checkbox"]:checked').val() != undefined){var Do_you_enjoy_the_opera = $('#Do_you_enjoy_the_opera[type="checkbox"]:checked').val();}
    else{var Do_you_enjoy_the_opera = 'No';}
    if($('#watched_Fools_Horses[type="checkbox"]:checked').val() != undefined){var watched_Fools_Horses = $('#watched_Fools_Horses[type="checkbox"]:checked').val();}
    else{var watched_Fools_Horses = 'No';}
    $('.cart_brew_coffee_in_front_of_customers').val(brew_coffee_front_of_customers);
    $('.cart_power_of_store').val(cart_power);
    $('.cart_Pick_Car').val(cart_Car);
    $('.cart_Do_you_enjoy_the_opera').val(Do_you_enjoy_the_opera);
    $('.cart_watched_Fools_Horses').val(watched_Fools_Horses);
    $('.cart_gym_subscription').val(gym_subscription);
//  End questions
    let brew_coffee_at_palce = $('.brew_your_coffee_block input[type="radio"]:checked').val(),
        cart_reoccurrence = $('.Reoccurrence_info input[type="radio"]:checked').attr('data-value'),
        cart_Support = $('.Support_info input[type="radio"]:checked').val();
    if($('.coffee_Traditional_barista_machine .toggle_box input[type="checkbox"]:checked').val() != undefined){var new_coffee_machine = $('.coffee_Traditional_barista_machine .toggle_box input[type="checkbox"]:checked').val();}
    else{var new_coffee_machine = 'No';}
    if($('#coffee_Machine_Training[type="checkbox"]:checked').val() != undefined){var cart_training = $('#coffee_Machine_Training[type="checkbox"]:checked').val();}
    else{var cart_training = 'No';}
    $('.cart_brew_coffee_at_palce').val(brew_coffee_at_palce);
    $('.cart_new_coffee_machine').val(new_coffee_machine);
    $('.cart_reoccurrence').val(cart_reoccurrence);
    $('.cart_training').val(cart_training);
    $('.cart_support').val(cart_Support);
  }
}
$(document).on('change','.Reoccurrence_info input[type="radio"]',function(){
  if($(this).is(':checked')){
    $('.cart_reoccurrence').val($(this).attr('data-value'));
    $('.product_subsciption').html($(this).val());
  }
});
$(document).on('change','#coffee_Machine_Training[type="checkbox"]',function(){
  if($(this).is(':checked')){$('.cart_training').val($(this).val());}
  else{$('.cart_training').val('No');}
});
$(document).on('change','.Support_info input[type="radio"]',function(){
  if($(this).is(':checked')){$('.cart_support').val($(this).val());}
});
$(document).on('change','.quantity-selector__value',function(e){
  var GetPrice = $(this).closest('.box_quantity_info').attr('data-price'),
      CPrice = 0,
      getweight = $(this).parent('.quantity_icons').siblings('.box_quantity').find('.weight').attr('data-value');
  $(this).parent('.quantity_icons').siblings('.box_quantity').find('.weight').html(parseInt(getweight) * $(this).val());
  $('.box_quantity_info').each(function(){
    CPrice = parseInt(CPrice) + parseInt($(this).attr('data-price') * $(this).find('.quantity-selector__value').val());
  });
  var CoffeePrice = CPrice;
  $('.atc_coffee_price').html(Shopify.formatMoney(CoffeePrice, window.theme.moneyFormat));
  $('.atc_coffee_price').attr('data-price',CoffeePrice);
  let addonprice = $('.atc_addons_price').attr('data-price'),
      machineprice = $('.atc_machine_price').attr('data-price'),
      coffeeprice = $('.atc_coffee_price').attr('data-price'),
      totalval = parseInt(coffeeprice) + parseInt(addonprice),
      grandtotalval = parseInt(machineprice) + parseInt(coffeeprice) + parseInt(addonprice);
  $('.grand_total_price').html(Shopify.formatMoney(grandtotalval, window.theme.moneyFormat));
  $('.subsciption_total_price').html(Shopify.formatMoney(totalval, window.theme.moneyFormat));
});
$(document).on('click','.product-form__add-button',function(e){
  e.preventDefault();
  $(this).html('Adding...').attr('disabled','disabled');
  var _this = $(this),
      this_form = $(this).closest('form'),
      formData = { 'items': [] },
      mval = $('.brew_your_coffee_block input[type="radio"]:checked').data('value'),
      Reoccurrence = $('.Reoccurrence_info input[type="radio"]:checked').val(),
      coffee_machine = $('.coffee_Traditional_barista_machine .toggle_box input[type="checkbox"]:checked').val();
  if(coffee_machine == 'Yes'){
    var cmachine_Id = $('.coffee_Traditional_barista_machine .toggle_box_content input[type="radio"]:checked').val();
    formData.items.push({ 'id': cmachine_Id,'quantity': 1 });
  }
  if(mval == 'coffee_Traditional_barista_machine' || mval == 'coffee_Brew_bags'){
    $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]').each(function(){
      if($(this).is(':checked')){
        let getHandle = $(this).attr('data-product-handle'),
            getId = $(this).val(),
            variantId = $('[data-productid="'+getId+'"]').val(),
            ProJSON = JSON.parse($('#productJSON-'+getId+'').html()),
            getqty = $('.quantity-selector__value[data-id="'+ProJSON.handle+'"]').val(),
            sell_plan = '';   
        if(getqty == null || getqty == undefined || getqty == ''){getqty = 1;} 
        if(Reoccurrence == 'Week'){if(ProJSON.selling_plan_groups.length != 0) {sell_plan = ProJSON.selling_plan_groups[0].selling_plans[0].id;}}
        else if(Reoccurrence == 'Month'){if(ProJSON.selling_plan_groups.length != 0) {sell_plan = ProJSON.selling_plan_groups[0].selling_plans[1].id;}}
        else if(Reoccurrence == 'Quarter'){if(ProJSON.selling_plan_groups.length != 0) {sell_plan = ProJSON.selling_plan_groups[0].selling_plans[2].id;}}
        
        if(sell_plan != ''){formData.items.push({ 'id': variantId,'quantity': getqty,'selling_plan': sell_plan });}
        else{formData.items.push({ 'id': variantId,'quantity': getqty });}
      }
    });
  }else{
    let getHandle = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').attr('data-product-handle'),
        getId = $('.coffee_product_box .Product_Box_Grid input[type="checkbox"]:checked').val(),
        variantId = $('[data-productid="'+getId+'"]').val(),
        ProJSON = JSON.parse($('#productJSON-'+getId+'').html()),
        getqty = $('.quantity-selector__value[data-id="'+ProJSON.handle+'"]').val(),
        sell_plan = '';
    if(getqty == null || getqty == undefined || getqty == ''){getqty = 1;} 
    if(Reoccurrence == 'Week'){if(ProJSON.selling_plan_groups.length != 0) {sell_plan = ProJSON.selling_plan_groups[0].selling_plans[0].id;}}
    else if(Reoccurrence == 'Month'){if(ProJSON.selling_plan_groups.length != 0) {sell_plan = ProJSON.selling_plan_groups[0].selling_plans[1].id;}}
    else if(Reoccurrence == 'Quarter'){if(ProJSON.selling_plan_groups.length != 0) {sell_plan = ProJSON.selling_plan_groups[0].selling_plans[2].id;}}
    
    if(sell_plan != ''){formData.items.push({ 'id': variantId,'quantity': getqty,'selling_plan': sell_plan });}
    else{formData.items.push({ 'id': variantId,'quantity': getqty });}
  }
  if(formData.items.length){
    fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
      if(response.ok == true){
        console.log('Added');
        this_form.submit();
        _this.html('Added in cart').removeAttr('disabled');
      }
    }).catch((error) => {
      console.log('error');
      console.log(error);
    });
  }
});